import { render } from "./NavbarTop.vue?vue&type=template&id=91538c08"
import script from "./NavbarTop.vue?vue&type=script&lang=ts"
export * from "./NavbarTop.vue?vue&type=script&lang=ts"
script.render = render

export default script